// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdvisoryMapController from "./advisory_map_controller"
application.register("advisory-map", AdvisoryMapController)

import AnomalyOverlayController from "./anomaly_overlay_controller"
application.register("anomaly-overlay", AnomalyOverlayController)

import AssessmentMapController from "./assessment_map_controller"
application.register("assessment-map", AssessmentMapController)

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CesiumMapController from "./cesium_map_controller"
application.register("cesium-map", CesiumMapController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import ChecklistStepController from "./checklist_step_controller"
application.register("checklist-step", ChecklistStepController)

import CollapseListController from "./collapse_list_controller"
application.register("collapse-list", CollapseListController)

import CollapsedFormController from "./collapsed_form_controller"
application.register("collapsed-form", CollapsedFormController)

import CuroConnectFormController from "./curo_connect_form_controller"
application.register("curo-connect-form", CuroConnectFormController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatepickerRangeController from "./datepicker_range_controller"
application.register("datepicker-range", DatepickerRangeController)

import DatatableReloaderController from "./datatable_reloader_controller"
application.register("datatable-reloader", DatatableReloaderController)

import DaterangeFilterController from "./daterange_filter_controller"
application.register("daterange-filter", DaterangeFilterController)

import DatetimeMomentController from "./datetime_moment_controller"
application.register("datetime-moment", DatetimeMomentController)

import DatetimeTooltipController from "./datetime_tooltip_controller"
application.register("datetime-tooltip", DatetimeTooltipController)

import DatetimepickerController from "./datetimepicker_controller"
application.register("datetimepicker", DatetimepickerController)

import DemoFlightProviderController from "./demo_flight_provider_controller"
application.register("demo-flight-provider", DemoFlightProviderController)

import DeviceMediaSelectionController from "./device_media_selection_controller"
application.register("device-media-selection", DeviceMediaSelectionController)

import DeviceMediaBatchUploadController from "./device_media_batch_upload_controller"
application.register("device-media-batch-upload", DeviceMediaBatchUploadController)

import DeviceMediaUploadController from "./device_media_upload_controller"
application.register("device-media-upload", DeviceMediaUploadController)

import DisableWheelScrollController from "./disable-wheel-scroll_controller"
application.register("disable-wheel-scroll", DisableWheelScrollController)

import DisableOnClickController from "./disable_on_click_controller"
application.register("disable-on-click", DisableOnClickController)

import DisplayMapController from "./display_map_controller"
application.register("display-map", DisplayMapController)

import DockAssets__RelayController from "./dock_assets/relay_controller"
application.register("dock-assets--relay", DockAssets__RelayController)

import DockControlFeedController from "./dock_control_feed_controller"
application.register("dock-control-feed", DockControlFeedController)

import DolbyStreamingController from "./dolby_streaming_controller"
application.register("dolby-streaming", DolbyStreamingController)

import DroneAssets__RelayController from "./drone_assets/relay_controller"
application.register("drone-assets--relay", DroneAssets__RelayController)

import ElementController from "./element_controller"
application.register("element", ElementController)

import ExpandableCardsController from "./expandable_cards_controller"
application.register("expandable-cards", ExpandableCardsController)

import FeatherController from "./feather_controller"
application.register("feather", FeatherController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FilteredRemoteDatatableController from "./filtered_remote_datatable_controller"
application.register("filtered-remote-datatable", FilteredRemoteDatatableController)

import FlightAdvisoryController from "./flight_advisory_controller"
application.register("flight-advisory", FlightAdvisoryController)

import FlightAdvisoryStagingController from "./flight_advisory_staging_controller"
application.register("flight-advisory-staging", FlightAdvisoryStagingController)

import FlightAdvisoryVersionLookupController from "./flight_advisory_version_lookup_controller"
application.register("flight-advisory-version-lookup", FlightAdvisoryVersionLookupController)

import FlightsBatchDeletionController from "./flights_batch_deletion_controller"
application.register("flights-batch-deletion", FlightsBatchDeletionController)

import FlightsSummaryController from "./flights_summary_controller"
application.register("flights-summary", FlightsSummaryController)

import FormRedirectController from "./form_redirect_controller"
application.register("form-redirect", FormRedirectController)

import GroupUsersChartController from "./group_users_chart_controller"
application.register("group-users-chart", GroupUsersChartController)

import GroupUsersSummaryController from "./group_users_summary_controller"
application.register("group-users-summary", GroupUsersSummaryController)

import HeteroConnect__HubStatusPollerController from "./hetero_connect/hub_status_poller_controller"
application.register("hetero-connect--hub-status-poller", HeteroConnect__HubStatusPollerController)

import HideOnSelectController from "./hide_on_select_controller"
application.register("hide-on-select", HideOnSelectController)

import HighlightOnSelectController from "./highlight_on_select_controller"
application.register("highlight-on-select", HighlightOnSelectController)

import HubAssets__AdsbPollerController from "./hub_assets/adsb_poller_controller"
application.register("hub-assets--adsb-poller", HubAssets__AdsbPollerController)

import HubAssets__DevicesController from "./hub_assets/devices_controller"
application.register("hub-assets--devices", HubAssets__DevicesController)

import HubAssets__EfbPollerController from "./hub_assets/efb_poller_controller"
application.register("hub-assets--efb-poller", HubAssets__EfbPollerController)

import HubAssets__RelayController from "./hub_assets/relay_controller"
application.register("hub-assets--relay", HubAssets__RelayController)

import KafkaConnectionTestController from "./kafka_connection_test_controller"
application.register("kafka-connection-test", KafkaConnectionTestController)

import KafkaIntegrationFormController from "./kafka_integration_form_controller"
application.register("kafka-integration-form", KafkaIntegrationFormController)

import LeftSideMenuController from "./left_side_menu_controller"
application.register("left-side-menu", LeftSideMenuController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LiveBooleanController from "./live_boolean_controller"
application.register("live-boolean", LiveBooleanController)

import LiveDroneMapController from "./live_drone_map_controller"
application.register("live-drone-map", LiveDroneMapController)

import LiveElevationController from "./live_elevation_controller"
application.register("live-elevation", LiveElevationController)

import LiveEnumController from "./live_enum_controller"
application.register("live-enum", LiveEnumController)

import LiveIconController from "./live_icon_controller"
application.register("live-icon", LiveIconController)

import LiveIndicatorController from "./live_indicator_controller"
application.register("live-indicator", LiveIndicatorController)

import LiveMapDemoFormController from "./live_map_demo_form_controller"
application.register("live-map-demo-form", LiveMapDemoFormController)

import LiveMessageController from "./live_message_controller"
application.register("live-message", LiveMessageController)

import LiveNumberController from "./live_number_controller"
application.register("live-number", LiveNumberController)

import LivePositionController from "./live_position_controller"
application.register("live-position", LivePositionController)

import LiveProgressController from "./live_progress_controller"
application.register("live-progress", LiveProgressController)

import LiveTimestampController from "./live_timestamp_controller"
application.register("live-timestamp", LiveTimestampController)

import LoadTurboFrameController from "./load_turbo_frame_controller"
application.register("load-turbo-frame", LoadTurboFrameController)

import LocalDatatableController from "./local_datatable_controller"
application.register("local-datatable", LocalDatatableController)

import LocalDatatables__InsertRowController from "./local_datatables/insert_row_controller"
application.register("local-datatables--insert-row", LocalDatatables__InsertRowController)

import LocalDatatables__RemoveRowController from "./local_datatables/remove_row_controller"
application.register("local-datatables--remove-row", LocalDatatables__RemoveRowController)

import MapPointPickerController from "./map_point_picker_controller"
application.register("map-point-picker", MapPointPickerController)

import MediaProcessorController from "./media_processor_controller"
application.register("media-processor", MediaProcessorController)

import MetismenuController from "./metismenu_controller"
application.register("metismenu", MetismenuController)

import MimerRoipDebugController from "./mimer_roip_debug_controller"
application.register("mimer-roip-debug", MimerRoipDebugController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationsMenuController from "./notifications_menu_controller"
application.register("notifications-menu", NotificationsMenuController)

import OnceController from "./once_controller"
application.register("once", OnceController)

import OperationAssessmentFormController from "./operation_assessment_form_controller"
application.register("operation-assessment-form", OperationAssessmentFormController)

import OperationAssessmentsMapController from "./operation_assessments_map_controller"
application.register("operation-assessments-map", OperationAssessmentsMapController)

import OperationsMapController from "./operations_map_controller"
application.register("operations-map", OperationsMapController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import RailsRemoteFormController from "./rails_remote_form_controller"
application.register("rails-remote-form", RailsRemoteFormController)

import RecentDatetimeController from "./recent_datetime_controller"
application.register("recent-datetime", RecentDatetimeController)

import RefreshFrameController from "./refresh_frame_controller"
application.register("refresh-frame", RefreshFrameController)

import ReloadTurboFrameController from "./reload_turbo_frame_controller"
application.register("reload-turbo-frame", ReloadTurboFrameController)

import RemoteDatatableController from "./remote_datatable_controller"
application.register("remote-datatable", RemoteDatatableController)

import RemoveableNodeController from "./removeable_node_controller"
application.register("removeable-node", RemoveableNodeController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ReviewFormController from "./review_form_controller"
application.register("review-form", ReviewFormController)

import Salesforce__ProcedureStepsFieldsetController from "./salesforce/procedure_steps_fieldset_controller"
application.register("salesforce--procedure-steps-fieldset", Salesforce__ProcedureStepsFieldsetController)

import SalesforceAccountsSearchSelectController from "./salesforce_accounts_search_select_controller"
application.register("salesforce-accounts-search-select", SalesforceAccountsSearchSelectController)

import SalesforceAssetsSummaryController from "./salesforce_assets_summary_controller"
application.register("salesforce-assets-summary", SalesforceAssetsSummaryController)

import SalesforceSkusSearchSelectController from "./salesforce_skus_search_select_controller"
application.register("salesforce-skus-search-select", SalesforceSkusSearchSelectController)

import SearchParamsController from "./search_params_controller"
application.register("search-params", SearchParamsController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectRemoteController from "./select_remote_controller"
application.register("select-remote", SelectRemoteController)

import SimpleDatatableController from "./simple_datatable_controller"
application.register("simple-datatable", SimpleDatatableController)

import SimulatedFlightsSummaryController from "./simulated_flights_summary_controller"
application.register("simulated-flights-summary", SimulatedFlightsSummaryController)

import SingleUploadController from "./single_upload_controller"
application.register("single-upload", SingleUploadController)

import SlimscrollController from "./slimscroll_controller"
application.register("slimscroll", SlimscrollController)

import SphereDjiStatus__DockStatusPollerController from "./sphere_dji_status/dock_status_poller_controller"
application.register("sphere-dji-status--dock-status-poller", SphereDjiStatus__DockStatusPollerController)

import SphereDjiStatus__DroneStatusPollerController from "./sphere_dji_status/drone_status_poller_controller"
application.register("sphere-dji-status--drone-status-poller", SphereDjiStatus__DroneStatusPollerController)

import StagedDeletionController from "./staged_deletion_controller"
application.register("staged-deletion", StagedDeletionController)

import StatusBadgeTitleController from "./status_badge_title_controller"
application.register("status-badge-title", StatusBadgeTitleController)

import StatusCableDebugController from "./status_cable_debug_controller"
application.register("status-cable-debug", StatusCableDebugController)

import SummaryItemController from "./summary_item_controller"
application.register("summary-item", SummaryItemController)

import TermsOfUseModalController from "./terms_of_use_modal_controller"
application.register("terms-of-use-modal", TermsOfUseModalController)

import TimeFromNowController from "./time_from_now_controller"
application.register("time-from-now", TimeFromNowController)

import TimepickerController from "./timepicker_controller"
application.register("timepicker", TimepickerController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TurboRedirectController from "./turbo_redirect_controller"
application.register("turbo-redirect", TurboRedirectController)

import UpdatePageTitleController from "./update_page_title_controller"
application.register("update-page-title", UpdatePageTitleController)

import UpdateSummaryItemController from "./update_summary_item_controller"
application.register("update-summary-item", UpdateSummaryItemController)

import WebrtcStreamController from "./webrtc_stream_controller"
application.register("webrtc-stream", WebrtcStreamController)

import WhepPlayerController from "./whep_player_controller"
application.register("whep-player", WhepPlayerController)
